import { render, staticRenderFns } from "./InspectionPanel.vue?vue&type=template&id=0b91a747&scoped=true&"
import script from "./InspectionPanel.vue?vue&type=script&lang=ts&"
export * from "./InspectionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionPanel.vue?vue&type=style&index=0&id=0b91a747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91a747",
  null
  
)

export default component.exports